import { errorInterceptor } from './core/interceptors/error.interceptor';
import { spinnerInterceptor } from './shared/interceptors/spinner.interceptor';
import { rsaEncryptionInterceptor } from './shared/interceptors/rsa-encryption.interceptor';
import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom, provideZoneChangeDetection} from '@angular/core';
import { RouterModule, RouterOutlet, provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations'
import { BrowserModule, provideClientHydration } from '@angular/platform-browser'
import { App_Route } from './app.routes';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { ToastrModule } from 'ngx-toastr';
import { ColorPickerModule } from 'ngx-color-picker';
import { FlatpickrDefaults } from 'angularx-flatpickr';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpLoaderFactory } from './core/functions/app-locale';
import {initGoogleMaps} from './core/functions/init-google-maps';

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initGoogleMaps,
      multi: true
    },
    provideRouter(App_Route),
    provideClientHydration(),
    RouterOutlet,
    RouterModule,
    BrowserModule,
    provideAnimations(),
    FlatpickrDefaults,
    BrowserModule,
    provideHttpClient(withInterceptors([rsaEncryptionInterceptor, spinnerInterceptor, authInterceptor, errorInterceptor])),
    provideCharts(withDefaultRegisterables()),
    provideZoneChangeDetection({ eventCoalescing: true }),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        }
      }),
      ColorPickerModule,
      CalendarModule.forRoot({
        provide: DateAdapter,
        useFactory: adapterFactory,
      }), ToastrModule.forRoot({
        timeOut: 15000, // 15 seconds
        closeButton: true,
        progressBar: true,
      }),),]
};





